export const SAMPLE_MAX_QUANTITY = 1;
export const TOAST_DURATION = 3000;
export const HEADER_HEIGHT_PX = 68;
export const DEFAULT_PRODUCT_WEIGHT = 25;
export const EXPIRED_PROPOSAL_TIME = 15000;
export const NEW_PROPOSAL_TIME = 10000;
export const COUNTRY_CODE = 'ID';
